/**
 * Side-Navigation: aktives Kapitel (Scroll-Spy) für Side- und
 * Mobile-Navi. Der Zeiger auf dem roten Balken gleitet zum aktiven
 * Kapitel (CSS-Transition auf transform, hier nur positioniert).
 *
 * data-navi-link       Kapitel-Link (Side- und Mobile-Navi)
 * data-navi-anchor     Kapitel-Section mit id
 * data-navi-pointer    Zeiger in der .side-bar (Desktop)
 */

const links = [...document.querySelectorAll('[data-navi-link]')]
const anchors = [...document.querySelectorAll('[data-navi-anchor]')]
const pointer = document.querySelector('[data-navi-pointer]')

const movePointer = () => {
  if (!pointer) return

  const active = document.querySelector('.side-navi-link.is-active')
  const rect = active?.getBoundingClientRect()

  // kein aktives Kapitel oder Side-Navi ausgeblendet (Mobile)
  if (!rect || !rect.height) {
    pointer.classList.remove('is-visible')
    return
  }

  const barTop = pointer.parentElement.getBoundingClientRect().top
  const y = rect.top + rect.height / 2 - barTop - pointer.offsetHeight / 2

  // erste Platzierung ohne Transition — der Zeiger soll nicht vom
  // Balken-Anfang her einschweben
  if (!pointer.classList.contains('is-visible')) {
    pointer.style.transition = 'none'
    pointer.style.transform = `translateY(${y}px)`
    void pointer.offsetHeight
    pointer.style.transition = ''
    pointer.classList.add('is-visible')
    return
  }

  pointer.style.transform = `translateY(${y}px)`
}

if (links.length && anchors.length) {
  const setActive = (id) => {
    links.forEach((link) =>
      link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`)
    )
    movePointer()
  }

  window.addEventListener('resize', movePointer)

  const observer = new IntersectionObserver(
    (entries) => {
      entries.filter((entry) => entry.isIntersecting).forEach((entry) => setActive(entry.target.id))
    },
    { rootMargin: '0px 0px -60% 0px' }
  )

  anchors.forEach((anchor) => observer.observe(anchor))

  // Mobile-Menü nach der Kapitelwahl wieder schliessen
  links.forEach((link) =>
    link.addEventListener('click', () => {
      if (document.body.classList.contains('overlay-menu-open')) {
        document.querySelector('[data-overlay-toggle="menu"]')?.click()
      }
    })
  )
}
